import App from './App.svelte';
import Conexoes from './Classes/Conexoes.js';
import { baseUrl } from './Classes/Stores.js';

const conexoes = new Conexoes();
conexoes.carregarCredenciais().then(() => {
  if (conexoes.baseUrl) {
    baseUrl.set(conexoes.baseUrl);
  }
}).catch(err => {
  console.error('Erro ao carregar credenciais:', err);
});

const app = new App({
  target: document.getElementById('app'),
  props: { url: window.location.pathname }
});

export default app;
